import React, { useEffect, useState } from "react";
import {
  AFTER_1_DAY,
  AFTER_2_DAYS,
  AFTER_3_DAYS,
  AFTER_4_DAYS,
  AFTER_5_DAYS,
  AUTO_POST_COMMENT_DAYS,
  NO_USE,
  SAVE
} from "../../text-data";

import OutlineBlueBtn2 from "../../components/buttons/OutlineBlueBtn2";

import ReviewApi from "../../apis/review.api";
import AppAlert from "../../components/AppAlert";
import PopupArea from "../../components/modal/PopupArea";
import Spinner from "../../components/spinner/Spinner";
import useAuth from "../../hooks/useAuth";

const dayList = [
  {
    label: NO_USE,
    value: 0,
  },
  {
    label: AFTER_1_DAY,
    value: 1,
  },
  {
    label: AFTER_2_DAYS,
    value: 2,
  },
  {
    label: AFTER_3_DAYS,
    value: 3,
  },
  {
    label: AFTER_4_DAYS,
    value: 4,
  },
  {
    label: AFTER_5_DAYS,
    value: 5,
  },
];

const DaysSetting = ({ defaultIndex, onChange }) => {
  const [activeIndex, setActiveIndex] = useState(defaultIndex ?? 0);
  const onClick = (value, index) => {
    setActiveIndex(index);
    if (onChange) {
      onChange(value);
    }
  };

  useEffect(() => {
    setActiveIndex(defaultIndex);
  }, [defaultIndex]);

  return (
    <div className="py-4 overflow-x-auto">
      <div className="flex gap-2">
        {dayList.map((item, index) => (
          <span
            className={`py-3 px-6 ${
              activeIndex === index
                ? "bg-appblue text-white"
                : "bg-light-aqua2 text-appblue"
            } rounded-md `}
            key={index}
            onClick={() => onClick(item.value, index)}
            style={{ flex: "1 0 auto" }}
          >
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
};

export default function ReviewSettingDays({setAdditionList}) {
  const [popupContent, setPopupContent] = useState(null);
  const closeModal = () => setPopupContent(null);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { ceoInfo } = useAuth();
  const [selectedDay, setSelectedDay] = useState(dayList[0].value);
  const [defaultIndex, setDefaultIndex] = useState(null);

  const onSave = async () => {
    if (!loading) {
      if (ceoInfo?.shop_idx) {
        try {
          setLoading(true);
          await ReviewApi.saveAutoPostCommentDay({
            shop_idx: ceoInfo?.shop_idx,
            post_after_days: selectedDay,
          });
          setOpenSuccess(true);
        } finally {
          setLoading(false);
        }
      }
    }
  };

  const getSavedSetting = async () => {
    if (ceoInfo?.shop_idx) {
      const { data } = await ReviewApi.getSavedSetting(ceoInfo?.shop_idx);
      if (data.data) {
        setAdditionList(data.data?.additionalComments)
        const activeKey = dayList.findIndex(
          (x) => x.value === data.data.post_after_days
        );
        setSelectedDay(data.data.post_after_days || 0);

        if (activeKey !== -1) {
          setDefaultIndex(activeKey);
        } else {
          setDefaultIndex(0);
        }
      }
    }
  };

  useEffect(() => {
    getSavedSetting();
  }, []);

  return (
    <div className="bg-white py-6 px-5 flex-col gap-6">
      <div className="flex flex-col mb-6">
        <div className="flex justify-between items-center mb-4">
          <div className="font-bold text-lg text-darkblue">
            {AUTO_POST_COMMENT_DAYS}
          </div>
          <OutlineBlueBtn2 className="py-1.5 px-4 w-fit" onClick={onSave}>
            {!loading ? SAVE : ' '}
            <Spinner color="#111B48" isLoading={loading} />
          </OutlineBlueBtn2>
        </div>
        <p>
          자동 등록되는 날짜를 설정하시면 해당 날짜에 등록 알림을 통해 가게를 한
          번 더 노출 시킬 수 있어요.
        </p>
      </div>
      {defaultIndex !== null && (
        <DaysSetting
          defaultIndex={defaultIndex}
          onChange={(value) => setSelectedDay(value)}
        />
      )}

      <PopupArea popupContent={popupContent} closeModal={closeModal} />

      <AppAlert
        title="자동 등록일 설정이 완료되었어요!"
        desc="다음 리뷰부터 자동 등록일이 적용돼요."
        open={openSuccess}
        onOk={() => setOpenSuccess(false)}
        okText="확인"
        type="success"
      />
    </div>
  );
}
